import { render, staticRenderFns } from "./PchPurchaseOrderList.vue?vue&type=template&id=1ecbcc36&lang=pug&"
import script from "./PchPurchaseOrderList.vue?vue&type=script&lang=js&"
export * from "./PchPurchaseOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchPurchaseOrderList.vue"
export default component.exports